export const US_STATES = [
  'AL',
  'AK',
  'AZ',
  'AR',
  'CA',
  'CO',
  'CT',
  'DE',
  'FL',
  'GA',
  'HI',
  'ID',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MD',
  'MA',
  'MI',
  'MN',
  'MS',
  'MO',
  'MT',
  'NE',
  'NV',
  'NH',
  'NJ',
  'NM',
  'NY',
  'NC',
  'ND',
  'OH',
  'OK',
  'OR',
  'PA',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VT',
  'VA',
  'WA',
  'WV',
  'WI',
  'WY',
] as const;

export const EMPTY_PROVIDERS_SEARCH_RESPONSE = {
  providers: [],
  facets: [],
  pagination: {
    page: 1,
    items: 0,
    total: 0,
  },
};

export enum PROVIDER_SCHEDULING_TYPES {
  OnlineFabric = 'OnlineFabric',
  OnlineOpenScheduling = 'OnlineOpenScheduling',
  Offline = 'Offline',
  None = 'None',
}

export const DAYS_RANGE = 7;

export const SITEMAP_CHUNK_SIZE = 100;

export const NAME_REGEX = /^[a-zA-Z\s'-]+$/;

// [DIR-831]: https://www.regular-expressions.info/email.html, Post describing the challenge with some proposed regexes, suggests this one is the most accurate
export const VALID_EMAIL_REGEX =
  /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/;
